import React, { Component } from "react";
import "../MainMenuOptions/MainMenuOptions.scss";
// import aboutUsIcon from "../../../assets/images/aboutus_icon.png";
// import facIcon from "../../../assets/images/fac_icon.png";
import doorIcon from "../../../assets/images/door_icon.png"; // - TODO - Temp Comment for PI LOAD
import { NavLink } from "react-router-dom";

const LinkInternalNav = 1, LinkInternalURL = 2, LinkExternalURL = 3;
// const LinkInternalNav = 1, LinkExternalURL = 3;
// const LinkInternalNav = 1, LinkInternalURL = 2;

class ExtraOptions extends Component {
  render() {
    
    // const menuOptions = [
    //   {
    //     id: 2,
    //     title: "Acts238Games.com",
    //     sub_title: "Return to the Website Homepage",
    //     link: "http://acts238games.com/",
    //     linktype: LinkInternalNav,
    //     iconurl: doorIcon,
    //   },
    // ];

    // {
    //   id: 1,
    //   title: "About Us",
    //   sub_title: "Info About the Quiz and its Creators",
    //   link: "/about-us",
    //   linktype: LinkInternalNav,
    //   iconurl: aboutUsIcon,
    // },
    // { TODO - Temp Comment for PI LOAD
    //   id: 2,
    //   title: "Acts238Games.com",
    //   sub_title: "Return to the Website Homepage",
    //   link: "http://acts238games.com/",
    //   linktype: LinkInternalURL,
    //   iconurl: doorIcon,
    // },

    const menuOptions = [
      {
        id: 2,
        title: "Exit Game",
        sub_title: "Return to Acts238Games",
        link: "https://www.acts238games.com/",
        linktype: LinkInternalURL,
        iconurl: doorIcon,
      },
      // {
      //   id: 3,
      //   title: "Family Apostolic",
      //   sub_title: "Head to Our Church Website",
      //   link: "https://familyapostolic.org/",
      //   linktype: LinkExternalURL,
      //   iconurl: facIcon,
      // },
    ];

    return (
      <div className="menu-options-container">
        <div className="options-list">
          {menuOptions.map((option, index) => {
            return option.linktype === LinkInternalNav ? (
              <NavLink
                className={
                  "single-option" + (option.sub_title === "" ? " disabled" : "")
                }
                // to={`${process.env.PUBLIC_URL}` + option.link}
                to={option.link}
                key={"extra_option_" + index}
              >
                <div className="option-glyghtextarea">
                  <div className="option-glyph">
                    <img src={option.iconurl} alt="" height="32" width="32" />
                  </div>
                  <div className="option-textarea">
                    <div className="option-title">{option.title}</div>
                    <div className="option-subtitle">{option.sub_title}</div>
                  </div>
                </div>
              </NavLink>
            ) : (
              // eslint-disable-next-line
              <a
              className={
                "single-option" + (option.sub_title === "" ? " disabled" : "")
              }
              // to={`${process.env.PUBLIC_URL}` + option.link}
              href={option.link}
              key={"extra_option_" + index}
              rel={option.linktype === LinkExternalURL ? "noreferrer" : ""}
              target={option.linktype === LinkExternalURL ? "_blank" : ""}
              >
              <div className="option-glyghtextarea">
                <div className="option-glyph">
                  <img src={option.iconurl} alt="" height="32" width="32" />
                </div>
                <div className="option-textarea">
                  <div className="option-title">{option.title}</div>
                  <div className="option-subtitle">{option.sub_title}</div>
                </div>
              </div>
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ExtraOptions;
